module.exports = __webpack_public_path__ + "img/features-content-img-1-en.6060f609.png";